module.exports = __webpack_public_path__ + "static/media/icon_extension_zip.2c4f41f4.svg";